
























	import Vue, { PropType } from 'vue';
    import _icons from '../../services/icons';
    import _moderation from '../../services/endpoints/moderation';
	import { Spieler } from 'models/Spieler';
	import { ModRaid } from 'models/Raid';
	import { DiscordMember } from 'models/Discord';
	import { UserRole } from '../../../../models/Enums';

    export default Vue.extend({
        name: "ModRaidSpielerListEntryComp",
		props: {
			spieler: Object as PropType<Spieler>,
			raid: Object as PropType<ModRaid>
		},
        computed: {
            avatarLink: function(): string {
                if (this.spieler.discord) {
                    return (this.spieler.discord as DiscordMember).avatar;
                } else {
                    return _icons.miscIcon('raid');
                }
            },
            promoteDemoteIcon: function(): string {
                if (this.spieler.role === 2) {
                    return 'star';
                } else {
                    return 'star_border';
                }
            },
			disabled: function(): boolean {
				return this.$vStore.getters.loggedInUser.role <= UserRole.Maz;
			}
        },
        methods: {
            openProfile: function(): void {
                this.$router.push(`/profil/${this.spieler.id}`);
            },
            changePlayerRole: async function(): Promise<void> {
                const role = this.spieler.role === 2 ? 0 : 2;
                await _moderation.setPlayerRole(this.raid.id, this.spieler.id, role, this.spieler.accname);
                this.$emit('refresh');
            },
            kick: async function(): Promise<void> {
                await _moderation.removeSpieler(this.raid.id, this.raid.name, this.spieler.id, this.spieler.accname);
                this.$emit('refresh');
            }
        }
    })
